import * as React from "react";

import { Box } from "@material-ui/core";
import * as Redux from "react-redux";

import { FieldSets, MerchantCollections } from "client/lib/apt-merchant";
import { RootState } from "client/store";

import { FormCollectionListItem } from "./FormCollectionListItem";

export interface FormCollection {
  collection: MerchantCollections["locations"] | MerchantCollections["owners"];
  collectionType: keyof MerchantCollections;
  deleteHandler: (index: number) => () => void;
  editHandler: (index: number) => () => void;
  getLabel: (index: number) => string;
}

export const FormCollectionList: React.FC<FormCollection> = ({
  collection,
  collectionType,
  deleteHandler,
  editHandler,
  getLabel,
}) => {
  const {
    error: { fieldErrorMap },
  } = Redux.useSelector(({ error }: RootState) => ({ error }));

  if (!collection.length) {
    return null;
  }

  const getFieldCollectionErrorByIndex = (idx: number) => {
    if (fieldErrorMap?.[collectionType]?.[idx]) {
      return Boolean(
        Object.keys(fieldErrorMap?.[collectionType]?.[idx] ?? {}).length
      );
    }
    return false;
  };

  // https://github.com/microsoft/TypeScript/issues/33591#issuecomment-841832390
  const _collection: Array<
    FieldSets.BusinessOwner | FieldSets.StoreLocation
  > = collection;

  return (
    <Box mb={2}>
      {_collection.map((fieldSet, idx: number) => (
        <FormCollectionListItem
          deleteHandler={deleteHandler(idx)}
          editHandler={editHandler(idx)}
          formCollectionListIndex={idx}
          formCollectionType={collectionType}
          hasErrors={getFieldCollectionErrorByIndex(idx)}
          key={fieldSet.fieldSetName}
          label={getLabel(idx)}
        />
      ))}
    </Box>
  );
};
